/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import colors from 'Themes/colors';
import { View } from 'react-native-web';

import NavActions from 'Services/Navigation/Actions';
import Selectors from 'Redux/Selectors';
import { RootState } from 'Redux/store';
import LoginSignUpModal from 'Containers/User/LoginSignUpModal';
import { connect } from 'react-redux';
import Searchbar from 'Components/Searchbar';
import Actions from 'Redux/Actions';

interface HamburgerModalProps{
    show?: boolean;
    onClose(): void;
    userId: string | undefined;
    productListLoading: boolean;
    searchQuery: string;
    setQuery: (query: string | '') => null
}
const HamburgerModal = (prop: HamburgerModalProps): JSX.Element => {
    const { onClose, show, userId, productListLoading, searchQuery, setQuery } = prop;
    const [isActive, setIsActive] = useState(false);
    const [loginModalVisible, setLoginModalVisible] = useState(false);

    const handleClickIcon = (icon: number) => {
        switch (icon) {
            case 1:
                window.open('https://www.instagram.com/tiansi.jewellery/', '_blank');
                onClose();
                break;
            case 2:
                window.open('https://www.facebook.com/TianSiJeweIIery', '_blank');
                onClose();
                break;
            case 3:
                window.open('https://www.tiktok.com/@tiansijewellery', '_blank');
                onClose();
                break;
            case 4:
                window.open('https://www.youtube.com/@tiansijewellery4693', '_blank');
                onClose();
                break;
            case 5:
                window.open('https://www.xiaohongshu.com/user/profile/64676fa5000000002b009ccb', '_blank');
                onClose();
                break;

            default:
                onClose();
                break;
        }
    };

    const handleClickTitle = (icon: number) => {
        switch (icon) {
            case 1:
                NavActions.navToProductListing();
                onClose();
                break;
            case 2:
                NavActions.navToAboutUs();
                onClose();
                break;
            case 3:
                window.open(`${process.env.REACT_APP_BASE_URL_OLD}/career`, '_blank');
                onClose();
                break;
            case 4:
                window.open(`${process.env.REACT_APP_BASE_URL_OLD}/contact-us`, '_blank');
                onClose();
                break;
            case 5:
                if (userId) {
                    NavActions.navToUserProfile();
                } else setLoginModalVisible(true);
                onClose();
                break;
            default:
                onClose();
                break;
        }
    };

    const onAuthorized = () => {
        setLoginModalVisible(false);
    };

    const onSignup = () => {
        setLoginModalVisible(false);
    };

    const handleOnKeyDown = (e: any) => {
        const { value } = e.target;
        if (e.key === 'Enter') {
            if (value.trim()) {
                NavActions.navToProductSearch(value);
                onClose();
            }
        }
    };

    const handleSearch = () => {
        if (searchQuery.trim()) NavActions.navToProductSearch(searchQuery);
        onClose();
    };

    const accrodianData = {
        content: [
            'Terms of Service',
            'Shipping & Returns',
            'Privacy Policy',
            'FAQs',
        ],
        url: [
            `${process.env.REACT_APP_BASE_URL_OLD}/terms-of-service`,
            `${process.env.REACT_APP_BASE_URL_OLD}/shipping-returns`,
            `${process.env.REACT_APP_BASE_URL_OLD}/privacy-policy`,
            `${process.env.REACT_APP_BASE_URL_OLD}/faqs`,
        ],
    };

    const renderAccordion = (title: string, content: string[], url: string[]) => {
        return (
            <div className='accordion-item' style={{ paddingBottom: 10 }}>
                <div className='accordion-title' onClick={() => setIsActive(!isActive)} aria-hidden style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                    <div css={styles.mainText}><p>{title}</p></div>
                    <div>{isActive ? (<img src='/assets/icons/ArrowDown.svg' alt='open' style={{ width: 30, height: 30 }} />) : (<img src='/assets/icons/ArrowDown.svg' alt='close' style={{ transform: 'rotate(180deg)', width: 30, height: 30 }} />)}</div>
                </div>
                {isActive && (
                    <div style={{ paddingTop: 20 }}>
                        { content.map((item, index) => {
                            return (
                                <a key={item} href={url[index]} target='_blank' rel='noreferrer' css={styles.subText}>
                                    <p>
                                        {item}
                                    </p>
                                </a>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div
            css={styles.cont1}
            style={{ opacity: !show ? 0 : 1, visibility: !show ? 'hidden' : 'visible' }}
        >
            <div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 40, paddingBottom: 40 }}>
                    <View
                        role='button'
                        tabIndex={0}
                        onClick={onClose}
                        onKeyPress={onClose}
                        style={{ cursor: 'pointer' }}
                    >
                        <img src='/assets/icons/Exit.svg' alt='' css={styles.closeIcon} />
                    </View>
                </div>

                <div>
                    <Searchbar
                        loading={productListLoading}
                        placeholder='Search'
                        onChange={setQuery}
                        onKeyDown={handleOnKeyDown}
                        onClicked={handleSearch}
                        value={searchQuery}
                        mainCss={styles.searchBar}
                        inputCss={styles.searchInput}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
                    <div
                        role='button'
                        tabIndex={0}
                        onClick={() => handleClickTitle(1)}
                        onKeyPress={() => handleClickTitle(1)}
                        css={styles.mainText}
                    >
                        <p>Products</p>
                    </div>

                    <div
                        role='button'
                        tabIndex={0}
                        onClick={() => handleClickTitle(2)}
                        onKeyPress={() => handleClickTitle(2)}
                        css={styles.mainText}
                    >
                        <p>About Us</p>
                    </div>

                    <div
                        role='button'
                        tabIndex={0}
                        onClick={() => handleClickTitle(3)}
                        onKeyPress={() => handleClickTitle(3)}
                        css={styles.mainText}
                    >
                        <p>Career</p>
                    </div>

                    <div
                        role='button'
                        tabIndex={0}
                        onClick={() => handleClickTitle(4)}
                        onKeyPress={() => handleClickTitle(4)}
                        css={styles.mainText}
                    >
                        <p>Contact Us</p>
                    </div>

                    {renderAccordion('Customer Support', accrodianData.content, accrodianData.url)}
                </div>
            </div>

            <div style={{ display: 'flex', gap: 20, paddingTop: 40 }}>
                <View style={{ cursor: 'pointer' }} onClick={() => handleClickIcon(1)}><img src='/assets/icons/Instagram.svg' alt='' css={styles.icon} /></View>
                <View style={{ cursor: 'pointer' }} onClick={() => handleClickIcon(2)}><img src='/assets/icons/Facebook.svg' alt='' css={styles.icon} /></View>
                <View style={{ cursor: 'pointer' }} onClick={() => handleClickIcon(3)}><img src='/assets/icons/Tiktok.svg' alt='' css={styles.icon} /></View>
                <View style={{ cursor: 'pointer' }} onClick={() => handleClickIcon(4)}><img src='/assets/icons/YouTube.svg' alt='' css={styles.icon} /></View>
                <View style={{ cursor: 'pointer' }} onClick={() => handleClickIcon(5)}><img src='/assets/icons/XiaoHongShu.svg' alt='' css={styles.icon} /></View>
            </div>

            <LoginSignUpModal
                show={() => setLoginModalVisible(true)}
                hide={() => setLoginModalVisible(false)}
                modal={loginModalVisible}
                onAuthorized={onAuthorized}
                onSignup={onSignup}
            />
        </div>
    );
};

const styles = {

    closeIcon: css({
        width: 40,
        height: 40,
    }),
    cont1: css({
        '@media(min-width: 300px)': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            position: 'fixed',
            width: '100%',
            height: '100vh',
            overflow: 'auto',
            backgroundColor: '#064E72',
            zIndex: 3,
            gap: 20,
            paddingLeft: 20,
            paddingRight: 30,
            paddingBottom: 70,
            transition: 'all .2s',

            '::-webkit-scrollbar': css({
            // Width of vertical scroll bar
                width: '10px',
                // Height of horizontal scroll bar
                height: '10px',

            }),
            '::-webkit-scrollbar-thumb': css({
                borderRadius: '8px',
                background: '#8CB5C9',
            }),
        },

        '@media(min-width: 768px)': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            position: 'fixed',
            width: '60%',
            height: '100vh',
            overflow: 'auto',
            backgroundColor: '#064E72',
            zIndex: 3,
            gap: 20,
            paddingLeft: 20,
            paddingRight: 30,
            paddingBottom: 70,
            transition: 'all .2s',

            '::-webkit-scrollbar': css({
            // Width of vertical scroll bar
                width: '10px',
                // Height of horizontal scroll bar
                height: '10px',

            }),
            '::-webkit-scrollbar-thumb': css({
                borderRadius: '8px',
                background: '#8CB5C9',
            }),
        },

        '@media(min-width: 1200px)': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            position: 'fixed',
            width: '25%',
            height: '100vh',
            top: 0,
            right: 0,
            overflow: 'auto',
            backgroundColor: '#064E72',
            zIndex: 3,
            gap: 20,
            paddingLeft: 60,
            paddingRight: 60,
            paddingBottom: 30,
            transition: 'all .2s',

            '::-webkit-scrollbar': css({
            // Width of vertical scroll bar
                width: '10px',
                // Height of horizontal scroll bar
                height: '10px',

            }),
            '::-webkit-scrollbar-thumb': css({
                borderRadius: '8px',
                background: '#8CB5C9',
            }),

            '& .btn_profile': css({
                display: 'none',
            }),
        },
    }),

    mainText: css({
        '@media(min-width: 320px)': {
            textDecoration: 'none',

            ':hover': {
                textDecoration: 'none',
            },

            '& p': {
                fontSize: '2rem',
                fontWeight: 700,
                color: 'white',
                letterSpacing: 1,
                transform: 'scale(1, 0.9)',
                margin: 0.0,
            },
        },
        '@media(min-width: 1200px)': {
            textDecoration: 'none',

            ':hover': {
                textDecoration: 'none',
            },

            '& p': {
                fontSize: '2.6rem',
                fontWeight: 700,
                color: 'white',
                letterSpacing: 1,
                transform: 'scale(1, 0.9)',
                margin: 0.0,
            },
        },
    }),
    subText: css({
        ':hover': {
            textDecoration: 'none',
            cursor: 'pointer',
        },

        '& p': {
            fontSize: '1.8rem',
            fontWeight: 700,
            color: '#8CB5C9',
            letterSpacing: 1,
            transform: 'scale(1, 0.9)',
            marginBottom: 20,
        },
    }),
    icon: css({
        width: 25,
        height: 25,
    }),
    searchBar: css({
        '@media(min-width: 320px)': {
            marginBottom: 50,
        },
        '@media(min-width: 1200px)': {
            display: 'none',
        },
    }),
    searchInput: css({
        '::placeholder': {
            color: 'white',
        },
        ':focus': {
            backgroundColor: 'transparent',
            outline: 'none !important',
            color: 'white',
        },

        '@media(min-width: 320px)': {
            width: '100%',
            height: 40,
            fontFamily: 'AcuminRPro',
            fontSize: '1.6rem',
            backgroundColor: 'transparent',
            border: 'none',
            borderBottom: '2px solid #8CB5C9',
            paddingLeft: 10,
        },
        '@media(min-width: 768px)': {
            width: '90%',
        },
    }),
};

const mapStateToProps = (state: RootState) => ({
    userId: Selectors.getUserId(state),
    productListLoading: Selectors.getProductsListAttempting(state),
    searchQuery: Selectors.getUiSearchQuery(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    setQuery: (query: string | '') => dispatch(Actions.uiSetSearchQuery(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HamburgerModal);
